import './axios-setup';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './axios-setup'; 
import App from './App';
import './index.css';
import { ENV_NAME } from './config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

document.body.classList.toggle('env-test', ENV_NAME === 'TEST');
